import React from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import { DatePicker, Flex, Input, Select, Typography } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";
import {
  addAbonement,
  editAbonement,
  getAbonementsClient,
} from "src/store/Slices/ClientsSlice";
import { openNotification } from "src/components/helpers/notification";
import { useEffect } from "react";

const EditAbonement = ({
  abonementModal,
  setAbonementModal,
  clientInfo,
  abonementInfo,
}) => {
  const dateFormatList = ["DD.MM.YYYY"];
  // HELPERS
  const dispatch = useDispatch();

  // STORE
  const abonementsList = useSelector(
    (state) => state.ClientsSlice.abonementsList
  );

  // STATE
  const [abonementClubId, setAbonementClubId] = useState(null);
  const [daysOfFrezze, setDaysOfFrezze] = useState(0);
  const [from, setFrom] = useState(dayjs());
  const [to, setTo] = useState();
  const [purchasePrice, setPurchasePrice] = useState(0);
  const [addedFrostDays, setAddedFrostDays] = useState(0);

  useEffect(() => {
    setAbonementClubId(abonementInfo?.abonementClubId);
    setDaysOfFrezze(abonementInfo?.frostUse ? abonementInfo?.frostUse : 0);
    setFrom(
      abonementInfo?.abonementFrom ? abonementInfo?.abonementFrom : dayjs()
    );
    setTo(abonementInfo?.abonementTo ? abonementInfo?.abonementTo : dayjs());
    setPurchasePrice(
      abonementInfo?.purchasePrice ? abonementInfo?.purchasePrice : 0
    );
    setAddedFrostDays(
      abonementInfo?.addedFrostDays ? abonementInfo?.addedFrostDays : 0
    );
  }, [abonementModal]);

  // FUNCTIONS
  const onClickAddAbonement = () => {
    dispatch(
      editAbonement({
        clientAbonementId: abonementInfo.id,
        clientId: clientInfo.id,
        abonementClubId: abonementClubId,
        from: from
          ? dayjs(from, "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss")
          : null,
        to: to ? dayjs(to, "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss") : null,
        frostUse: daysOfFrezze ? daysOfFrezze : 0,
        purchasePrice: purchasePrice ? purchasePrice : 0,
        addedFrostDays: addedFrostDays ? addedFrostDays : 0,
      })
    ).then(() => {
      dispatch(getAbonementsClient({ clientId: clientInfo.id }));
      setAbonementModal(false);
    });
  };

  return (
    <CModal
      alignment="center"
      visible={abonementModal}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setAbonementModal(false);
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">
          {"Редактировать абонемент"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Абонемент</Typography.Title>
              <Select
                style={{ width: "100%" }}
                options={abonementsList?.data?.value}
                onChange={(value) => {
                  setAbonementClubId(value);
                }}
                placeholder={"Выбрать"}
                value={abonementClubId}
                disabled={true}
              />
            </div>

            <div>
              <Typography.Title level={5}>
                Начало действия абонемента
              </Typography.Title>
              <DatePicker
                style={{ width: "100%" }}
                format={"DD.MM.YYYY"}
                placement={"topRight"}
                onChange={(date, dateString) => {
                  setFrom(date);
                }}
                defaultValue={dayjs(from, dateFormatList)}
              />
            </div>

            <div>
              <Typography.Title level={5}>
                Конец действия абонемента
              </Typography.Title>
              <DatePicker
                style={{ width: "100%" }}
                format={"DD.MM.YYYY"}
                placement={"topRight"}
                onChange={(date, dateString) => {
                  setTo(date);
                }}
                defaultValue={dayjs(to, dateFormatList)}
              />
            </div>

            <div>
              <Typography.Title level={5}>
                Использовано заморозки, дней
              </Typography.Title>
              <Input
                defaultValue=""
                type="number"
                value={daysOfFrezze}
                onChange={(e) => {
                  setDaysOfFrezze(
                    e.currentTarget.value >= 0 ? e.currentTarget.value : ""
                  );
                }}
              />
            </div>

            <div>
              <Typography.Title level={5}>
                Добавленных дней заморозки
              </Typography.Title>
              <Input
                defaultValue=""
                type="number"
                value={addedFrostDays}
                onChange={(e) => {
                  setAddedFrostDays(
                    e.currentTarget.value >= 0 ? e.currentTarget.value : ""
                  );
                }}
              />
            </div>

            <div>
              <Typography.Title level={5}>Цена покупки</Typography.Title>
              <Input
                defaultValue=""
                type="number"
                value={purchasePrice}
                onChange={(e) => {
                  setPurchasePrice(
                    e.currentTarget.value >= 0 ? e.currentTarget.value : 0
                  );
                }}
              />
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setAbonementModal(false);
          }}
          style={{ color: "#fff" }}
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickAddAbonement} style={{ color: "#fff" }}>
          Редактировать
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default EditAbonement;
